import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import React, { CSSProperties } from "react";
import elements from "./Links.module.scss";
import { NavLink } from "../../../shared/components/Navbar/Navbar";
import { useRouterContext } from "../../../../context/RouterContext";
import LinkButton from "../../../shared/components/EffektButton/LinkButton";
export type LinkType = {
  _type: "link";
  _key: string;
  title?: string;
  url?: string;
  newtab?: boolean;
};
export type LinksProps = {
  links: (LinkType | NavLink)[];
  buttons?: boolean;
  newtab?: boolean;
};
export const Links: React.FC<LinksProps> = t0 => {
  const $ = _c(8);
  const {
    links,
    buttons,
    newtab
  } = t0;
  const {
    articlesPagePath,
    fundraisersPath
  } = useRouterContext();
  let t1;
  if ($[0] !== articlesPagePath || $[1] !== buttons || $[2] !== fundraisersPath || $[3] !== links || $[4] !== newtab) {
    t1 = links && links.filter(validateLink).map(link => {
      const {
        href,
        isFundraiser
      } = getHref(link, articlesPagePath, fundraisersPath);
      return <li key={link._key}>{buttons ? <LinkButton title={link.title ?? ""} url={href} prefetch={isFundraiser ? false : undefined} /> : <LinkComponent link={link} newtab={newtab} />}</li>;
    });
    $[0] = articlesPagePath;
    $[1] = buttons;
    $[2] = fundraisersPath;
    $[3] = links;
    $[4] = newtab;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = <ul className={elements.links}>{t1}</ul>;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export const LinkComponent: React.FC<{
  link: LinkType | NavLink;
  children?: string;
  style?: CSSProperties;
  newtab?: boolean;
}> = t0 => {
  const $ = _c(16);
  const {
    link,
    children,
    style,
    newtab
  } = t0;
  const {
    articlesPagePath,
    fundraisersPath
  } = useRouterContext();
  let href;
  let isFundraiser;
  let openInNewTab;
  let t1;
  if ($[0] !== articlesPagePath || $[1] !== fundraisersPath || $[2] !== link || $[3] !== newtab) {
    ({
      href,
      isFundraiser
    } = getHref(link, articlesPagePath, fundraisersPath));
    openInNewTab = link._type === "link" && link.newtab || newtab;
    t1 = isAbsoluteUrl(href) ? "a" : Link;
    $[0] = articlesPagePath;
    $[1] = fundraisersPath;
    $[2] = link;
    $[3] = newtab;
    $[4] = href;
    $[5] = isFundraiser;
    $[6] = openInNewTab;
    $[7] = t1;
  } else {
    href = $[4];
    isFundraiser = $[5];
    openInNewTab = $[6];
    t1 = $[7];
  }
  const LinkElement = t1;
  const t2 = isFundraiser ? false : undefined;
  const t3 = openInNewTab ? "_blank" : "";
  const t4 = openInNewTab ? "noopener noreferrer" : undefined;
  const t5 = link.title ? `→ ${link.title}` : `${children}${openInNewTab ? " \u2197" : ""}`;
  let t6;
  if ($[8] !== LinkElement || $[9] !== href || $[10] !== style || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <LinkElement href={href} prefetch={t2} target={t3} rel={t4} onClick={_temp} style={style}>{t5}</LinkElement>;
    $[8] = LinkElement;
    $[9] = href;
    $[10] = style;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export const isAbsoluteUrl = (href: string) => /^[a-z][a-z0-9+.-]*:/i.test(href);
export const getHref = (link: NavLink | LinkType, articlesPagePath: string[], fundraisersPath: string[]): {
  href: string;
  isFundraiser: boolean;
} => {
  if (link._type === "navitem") {
    switch (link.pagetype) {
      case "article_page":
        return {
          href: `/${[...articlesPagePath, link.slug].join("/")}`,
          isFundraiser: false
        };
      case "fundraiser_page":
        return {
          href: `/${[...fundraisersPath, link.slug].join("/")}`,
          isFundraiser: true
        };
      default:
        return {
          href: `/${link.slug}`,
          isFundraiser: false
        };
    }
  } else {
    return {
      href: link.url ?? (link as any).href ?? "",
      isFundraiser: false
    };
  }
};
const validateLink: (link: LinkType | NavLink) => boolean = link => {
  if (link._type === "navitem") return link.slug !== undefined && link.slug !== null;else return link.url !== undefined && link.url !== null;
};
function _temp(e) {
  e.currentTarget.blur();
}